export default "__VITE_ASSET__4e186428__"